import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ViewModeService } from './view-mode.service';

/**
 * Gác trên shell desktop: nếu người dùng ưu tiên bản mobile
 * (đã ép 'mobile', hoặc chưa chọn nhưng đang chạy PWA đã cài — display-mode: standalone)
 * thì đưa vào /mobile. Ép 'desktop' thì không bao giờ chuyển.
 */
export const mobileViewRedirectGuard: CanActivateFn = () => {
  const viewMode = inject(ViewModeService);
  const router = inject(Router);
  if (viewMode.shouldPreferMobile()) {
    return router.createUrlTree(['/mobile']);
  }
  return true;
};
